/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductAddonCard
 */
export interface ProductAddonCard {
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    googleProductCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductAddonCard
     */
    selectedOptions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    product?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAddonCard
     */
    name?: string;
}

/**
 * Check if a given object implements the ProductAddonCard interface.
 */
export function instanceOfProductAddonCard(value: object): boolean {
    return true;
}

export function ProductAddonCardFromJSON(json: any): ProductAddonCard {
    return ProductAddonCardFromJSONTyped(json, false);
}

export function ProductAddonCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAddonCard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'googleProductCategory': json['googleProductCategory'] == null ? undefined : json['googleProductCategory'],
        'selectedOptions': json['selectedOptions'] == null ? undefined : json['selectedOptions'],
        'variantId': json['variantId'] == null ? undefined : json['variantId'],
        'product': json['product'] == null ? undefined : json['product'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ProductAddonCardToJSON(value?: ProductAddonCard | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'brand': value['brand'],
        'googleProductCategory': value['googleProductCategory'],
        'selectedOptions': value['selectedOptions'],
        'variantId': value['variantId'],
        'product': value['product'],
        'name': value['name'],
    };
}

